import { createReducer, on } from '@ngrx/store';

import * as actions from '../actions/apps.actions';
import * as sessionActions from '../actions/session.actions';
import { appsState } from '../states/apps.state';

export const APPS_REDUCER_KEY = 'apps';
export const APPS_REDUCER = createReducer(
    appsState,
    on(sessionActions.CompletedSwitchToOrganization, (state, { organization }) => ({
        ...state,
        currentOrganizationId: organization?.id,
    })),
    on(actions.SetAppHelpDocumentation, (state, { serviceId, helpDocuments }) => ({
        ...state,
        appsHelpDocumentsByServiceId: {
            ...state.appsHelpDocumentsByServiceId,
            [serviceId]: helpDocuments,
        },
    })),
    on(actions.SetAppBridgeNodes, (state, { assetId, bridgeNodes }) => ({
        ...state,
        bridgeServices: {
            ...state.bridgeServices,
            [assetId]: bridgeNodes,
        },
    })),
    on(actions.SetSubscribedApps, (state, { services, organizationId }) => {
        return {
            ...state,
            subscribedServices: {
                ...state.subscribedServices,
                [organizationId]: services,
            },
        };
    }),
    on(actions.SetAppMetaData, (state, { serviceId, metaData }) => ({
        ...state,
        assetsMetaData: {
            ...state.assetsMetaData,
            [serviceId]: {
                ...state.assetsMetaData[serviceId],
                [metaData.uid]: metaData,
            },
        },
    })),
    on(actions.SetAppMetaDataPermissions, (state, { serviceId, metaDataPermissions }) => ({
        ...state,
        assetsMetaDataPermissions: {
            ...state.assetsMetaDataPermissions,
            [serviceId]: metaDataPermissions,
        },
    })),
    on(actions.SetReconConfiguration, (state, { serviceId, configuration }) => ({
        ...state,
        reconConfiguration: {
            ...state.reconConfiguration,
            [serviceId]: configuration,
        },
    })),
    on(actions.SetAppLoading, (state, { serviceId, loading, property }) => ({
        ...state,
        loading: {
            ...state.loading,
            [serviceId]: {
                ...state.loading[serviceId],
                [property || 'meta']: loading,
            },
        },
    })),
    on(actions.ClearAllAppsLoadings, state => ({
        ...state,
        loading: {},
    })),
    on(actions.SetSelectedAppRestApiName, (state, { restApiName }) => ({
        ...state,
        selectedApp: {
            ...state.selectedApp,
            restApiName,
        },
    })),
    on(actions.SetSelectedBridgeRestApiName, (state, { restApiName }) => ({
        ...state,
        selectedApp: {
            ...state.selectedApp,
            bridgeRestApiName: restApiName,
        },
    })),
    on(actions.SetSelectedPackageRestApiName, (state, { restApiName }) => ({
        ...state,
        selectedApp: {
            ...state.selectedApp,
            packageRestApiName: restApiName,
        },
    })),
    on(actions.SetSelectedAppServiceId, (state, { serviceId }) => ({
        ...state,
        selectedApp: {
            ...state.selectedApp,
            serviceId,
        },
    })),
    on(actions.SetSelectedBridgeServiceId, (state, { serviceId }) => ({
        ...state,
        selectedApp: {
            ...state.selectedApp,
            bridgeServiceId: serviceId,
        },
    })),
    on(actions.SetSelectedPackageServiceId, (state, { serviceId }) => ({
        ...state,
        selectedApp: {
            ...state.selectedApp,
            packageServiceId: serviceId,
        },
    })),
    on(actions.SetSelectedAppCategory, (state, { category }) => ({
        ...state,
        selectedApp: {
            ...state.selectedApp,
            category,
        },
    })),
    on(actions.SetSelectedAppEntity, (state, { entityId }) => ({
        ...state,
        selectedApp: {
            ...state.selectedApp,
            entityId,
        },
    })),
    on(actions.SetAppTemplate, (state, { organizationId, serviceId, template }) => ({
        ...state,
        appsTemplate: {
            ...state.appsTemplate,
            [organizationId]: {
                ...state.appsTemplate[organizationId],
                [serviceId]: template,
            },
        },
    })),
    on(actions.SetAppConfigurator, (state, action) => ({
        ...state,
        appConfigurators: {
            ...state.appConfigurators,
            [action.serviceId]: {
                ...state.appConfigurators?.[action.serviceId],
                [action.assetMetaUID]: action.configurator,
            },
        },
    })),
    on(actions.SetAssetWithLatestVersion, (state, { serviceId, asset }) => ({
        ...state,
        assetsWithLatestVersion: {
            ...state.assetsWithLatestVersion,
            [serviceId]: asset,
        },
    })),
    on(actions.SetAssetsForSubscriptionApprovalFilters, (state, { assets }) => ({
        ...state,
        assetsForSubscriptionApprovalFilters: assets,
    })),
    on(actions.SetPackageGroupApps, (state, action) => ({
        ...state,
        packagedAppsMap: {
            ...state.packagedAppsMap,
            [action.serviceId]: action.packagedApps,
        },
    })),
    on(actions.SetTaxonomyApp, (state, action) => ({
        ...state,
        taxonomyApp: action.taxonomyApp,
    })),
    on(actions.SetAppDetailsThroughApi, (state, { appDetails, organizationId }) => {
        const nonMappedServices = state.nonMappedServices[organizationId];
        if (nonMappedServices?.find(s => s.serviceId === appDetails?.serviceId)) {
            return state;
        }
        return {
            ...state,
            nonMappedServices: {
                ...(state.nonMappedServices || {}),
                [organizationId]: [...(state.nonMappedServices?.[organizationId] || []), appDetails],
            },
        };
    }),
    on(actions.SetAppTags, (state, { serviceId, tags, organizationId }) => {
        return {
            ...state,
            nonMappedServices: {
                ...(state.nonMappedServices || {}),
                [organizationId]: [...(state.nonMappedServices?.[organizationId] || [])]?.map(s =>
                    s.serviceId === serviceId ? { ...s, tags } : s
                ),
            },
        };
    }),
    on(sessionActions.SessionLogoutSuccessfull, () => appsState)
);
